import {axiosInstance} from "@/plugins/axios";

export async function getSupplier(id: string) {
  const response = await axiosInstance.get(`suppliers/${id}`);
  return response.data;
}
